/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const StarButton = styled.button`
  padding: ${({ padding }) => padding || '0'};
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 13px !important;
  .iconfont {
    color: #F0B90A;
  }
`;

export type Props = {
  active?: boolean,
  padding?: string,
};

const StarIcon = (props: Props) => {
  const { active } = props;
  if (active) {
    return (
      <StarButton
        className="iconfont icon-collect-fill active"
        aria-label={`${active ? 'remove' : 'add'} favorite`}
        padding={props.padding}
        {...props}
      />
    );
  }
  return (
    <StarButton
      className="iconfont icon-collect active"
      aria-label={`${active ? 'remove' : 'add'} favorite`}
      padding={props.padding}
      {...props}
    />
  );
};

StarIcon.defaultProps = {
  active: false,
  padding: '0',
};

export default StarIcon;
